import { PropsWithChildren } from 'react';
import { buildHeImgixUrl } from '../../../components/images/imgix';
import { ClickableLogo } from '../../SearchHeader/ClickableLogo/ClickableLogo';
import { HeadingWrapper, HeroContent, Logo, Title, HeroImage } from './Heading.styles';

export type Props = PropsWithChildren<{
  titleText: string;
  imgxPath: string;
}>;

export const Heading = ({ titleText, imgxPath, children }: Props) => (
  <HeadingWrapper>
    <HeroImage
      imgxUrl={buildHeImgixUrl(imgxPath, {
        w: 600,
      })}
    />
    <HeroContent>
      <a href="https://healthengine.com.au">
        <Logo>
          <ClickableLogo textLogo={true} />
        </Logo>
      </a>
      <Title>{titleText}</Title>
      {children}
    </HeroContent>
  </HeadingWrapper>
);
